// src/components/CustomerSummary/components/Top3StudyIndicationsTable.jsx
// ============================================================================
// BLOCK CS.UI.TOP3IND.0 — Top3StudyIndicationsTable (read-only + resizable)
// ----------------------------------------------------------------------------
// INPUT FORMAT (tab-delimited; 2 columns)
// - Group header rows: "<StudyType>\t"
// - Nested rows: "\t<indication and rank>" (col1 blank)
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function Top3StudyIndicationsTable({ text, columnWidths, onColumnWidthsChange }) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.top3StudyIndications}
    />
  );
}
